(function ($) {

  // ─────────────────────────────────────────
  // Core AJAX bookmark function
  // ─────────────────────────────────────────
  function doBookmarkAction(btn) {
    $('#loading').addClass('d-flex');

    const postId = btn.data('post-id');
    const isDashboard = btn.data('dashboard') || false;

    if (!postId) {
      console.error('Missing post ID for bookmark action');
      $('#loading').removeClass('d-flex');
      return;
    }

    $.post(
      window.ajax_callback_data.ajax_url,
      {
        action: 'qcs_toggle_bookmark',
        post_id: postId,
        nonce: window.ajax_callback_data.ajax_nonce,
      },
      function (response) {
        if (response.success) {
          if (isDashboard) {
            location.reload();
          } else {
            btn.toggleClass('is-bookmarked');
            $('#loading').removeClass('d-flex');
          }
        } else {
          console.error('AJAX error:', response.data);
          $('#loading').removeClass('d-flex');
        }
      }
    ).fail(function (xhr) {
      console.error('AJAX request failed:', xhr.responseText);
      $('#loading').removeClass('d-flex');
    });
  }

  // ─────────────────────────────────────────
  // Click handler
  // ─────────────────────────────────────────
  $(document).on('click', 'button.bookmark-btn', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // ← stop any other handlers firing

    const btn = $(this);
    const isDashboard = btn.data('dashboard') || false;
    const isBookmarked = btn.hasClass('is-bookmarked');
    const $modal = $('#unsaveConfirmModal');

    // Show confirmation modal only on dashboard unsave action
    if (isDashboard && isBookmarked && $modal.length) {

      // Use jQuery Bootstrap modal to guarantee correct init
      $modal.modal('show');

      // .off() prevents stacking listeners
      $('#confirmUnsaveBtn').off('click.confirmUnsave').on('click.confirmUnsave', function () {
        $modal.modal('hide');
        doBookmarkAction(btn); // ← AJAX runs ONLY after confirm
      });

      return; 
    }

    // Non-dashboard or adding a bookmark — run AJAX directly
    doBookmarkAction(btn);
  });

})(jQuery);